export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9089.39d4b515.jpg";